module.exports = __webpack_public_path__ + "static/media/forgotPassword.9ed537b5.png";